"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommonSections = exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _nuiIntl = require("@concur/nui-intl");

var _reactRedux = require("react-redux");

var _AppCategory = _interopRequireDefault(require("../listings/AppCategory"));

var _LoadingIndicator = _interopRequireDefault(require("./LoadingIndicator"));

var ListingsActions = _interopRequireWildcard(require("../listings/listingsModule"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// let SEED = Date.now();
// function random() {
//   const x = Math.sin(SEED++) * 10000;
//   return x - Math.floor(x);
// }
var CommonSections =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CommonSections, _React$Component);

  function CommonSections() {
    _classCallCheck(this, CommonSections);

    return _possibleConstructorReturn(this, _getPrototypeOf(CommonSections).apply(this, arguments));
  }

  _createClass(CommonSections, [{
    key: "renderNoResults",
    value: function renderNoResults() {
      return _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-12",
        id: "popular-collection"
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "NoSearchResults"
      })));
    }
  }, {
    key: "buildCollectionSet",
    value: function buildCollectionSet(popularListings, popularForEnterprise, allListingsSection, nonshuffledAllListingsSection, partitionedAllApps) {
      var listings = this.props.listings;
      var MIN_APP_NUM = 20;
      var MIN_NUM_LISTINGS = allListingsSection.length >= MIN_APP_NUM;

      var chooseEnterpriseTitle = function chooseEnterpriseTitle(categoryDescription) {
        if (!listings.category || listings.category.slug === 'all') {
          return _react.default.createElement(_nuiIntl.FormattedMessage, {
            id: "EnterpriseAppsCollection"
          });
        }

        return _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "CategoryForEnterprise",
          values: {
            category: categoryDescription
          }
        });
      };

      var choosePopularForCategoryTitle = function choosePopularForCategoryTitle(categoryDescription) {
        if (!listings.category || listings.category.slug === 'all') {
          return _react.default.createElement(_nuiIntl.FormattedMessage, {
            id: "PopularConnectionsCollection"
          });
        }

        return _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "PopularForCategoryCollection",
          values: {
            category: categoryDescription
          }
        });
      };

      var chooseAllCategoryTitle = function chooseAllCategoryTitle(categoryDescription) {
        if (!listings.category || listings.category.slug === 'all') {
          return MIN_NUM_LISTINGS ? _react.default.createElement(_nuiIntl.FormattedMessage, {
            id: "AllAppsCollection"
          }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
            id: "Connections"
          });
        }

        return MIN_NUM_LISTINGS ? _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "AllForCategoryCollection",
          values: {
            category: categoryDescription
          }
        }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "ConnectionsForCategory",
          values: {
            category: categoryDescription
          }
        });
      };

      if (!popularListings.length && !popularForEnterprise.length && !allListingsSection.length) {
        return this.renderNoResults();
      }

      var categoryDescription = listings.category ? listings.category.description : ''; // we don't want two collections showing the same listings

      if ((!popularListings.length || !popularForEnterprise.length) && popularListings.length < 10 && popularForEnterprise.length < 10) {
        return _react.default.createElement("div", {
          className: "row"
        }, _react.default.createElement("div", {
          className: "col-xs-12",
          id: "all-listings"
        }, _react.default.createElement(_AppCategory.default, {
          categoryTitle: chooseAllCategoryTitle(categoryDescription),
          categorySubtitle: _react.default.createElement(_nuiIntl.FormattedMessage, {
            id: "AllAppsCollectionSubtitle"
          }),
          listings: partitionedAllApps,
          isLoggedIn: this.props.userPrefs.isLoggedIn,
          windowWidth: window.innerWidth
        })));
      }

      return _react.default.createElement("div", null, MIN_NUM_LISTINGS && _react.default.createElement("div", {
        id: "popular-section",
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-12",
        id: "popular-collection"
      }, _react.default.createElement(_AppCategory.default, {
        categoryTitle: choosePopularForCategoryTitle(categoryDescription),
        categorySubtitle: _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "PopularConnsCollectionSubtitle"
        }),
        listings: popularListings,
        isLoggedIn: this.props.userPrefs.isLoggedIn,
        windowWidth: window.innerWidth
      }))), _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-12",
        id: "popular-for-enterprise"
      }, _react.default.createElement(_AppCategory.default, {
        categoryTitle: chooseEnterpriseTitle(categoryDescription),
        categorySubtitle: _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "EnterpriseAppsCollectionSubtitle"
        }),
        listings: popularForEnterprise,
        isLoggedIn: this.props.userPrefs.isLoggedIn,
        windowWidth: window.innerWidth
      }))), _react.default.createElement("div", {
        id: "connections-section",
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-12",
        id: "all-listings"
      }, _react.default.createElement(_AppCategory.default, {
        categoryTitle: chooseAllCategoryTitle(categoryDescription),
        categorySubtitle: _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "AllAppsCollectionSubtitle"
        }),
        listings: MIN_NUM_LISTINGS ? allListingsSection : nonshuffledAllListingsSection,
        isLoggedIn: this.props.userPrefs.isLoggedIn,
        windowWidth: window.innerWidth
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$listings = this.props.listings,
          listingsReadyState = _this$props$listings.listingsReadyState,
          filtered = _this$props$listings.filtered;
      var isLoaded = listingsReadyState === ListingsActions.LISTINGS_FETCHED;

      if (listingsReadyState === ListingsActions.LISTINGS_FETCH_FAILED) {
        return _react.default.createElement("p", null, "Failed to fetch Listings");
      }

      function prioritySort(a, b) {
        if (a.core.priority < b.core.priority) return -1;
        if (a.core.priority > b.core.priority) return 1;
        return 0;
      }

      var partitionedListings = _lodash.default.partition(filtered.concat([]).sort(prioritySort), function (listing) {
        return !listing.core.listingDisabled;
      });

      var partitionedAllApps = _lodash.default.flatten(partitionedListings);

      var popularListings = _lodash.default.chain(partitionedAllApps).filter(function (listing) {
        return listing.core.clientOptInType === 'USER';
      }).take(10).value();

      var popularForEnterprise = _lodash.default.chain(partitionedAllApps).filter(function (listing) {
        return listing.core.clientOptInType === 'ADMIN';
      }).sort(prioritySort).value();

      var shuffledPartionedAllApps = _lodash.default.shuffle(partitionedListings[0]).concat(_lodash.default.shuffle(partitionedListings[1]));

      var nonshuffledAllListingsSection = _lodash.default.chain(partitionedAllApps).filter(function (listing) {
        return listing.core.clientOptInType === 'USER';
      }).value();

      var allListingsSection = _lodash.default.chain(shuffledPartionedAllApps).filter(function (listing) {
        return listing.core.clientOptInType === 'USER';
      }).value();

      return _react.default.createElement("div", {
        style: {
          minHeight: '1151px'
        }
      }, _react.default.createElement(_LoadingIndicator.default, {
        isLoaded: isLoaded,
        beta: this.props.profile && this.props.profile.betas['concur-ui-spinner']
      }, this.buildCollectionSet(popularListings, popularForEnterprise, allListingsSection, nonshuffledAllListingsSection, partitionedAllApps)));
    }
  }]);

  return CommonSections;
}(_react.default.Component);

exports.CommonSections = CommonSections;
CommonSections.propTypes = {
  listings: _propTypes.default.object,
  user: _propTypes.default.object,
  userPrefs: _propTypes.default.shape({
    isLoggedIn: _propTypes.default.bool
  })
};

function mapStateToProps(state) {
  return {
    listings: state.listings,
    user: state.user,
    userPrefs: state.userPrefs,
    profile: state.userProfile.profile
  };
}

var _default = (0, _reactRedux.connect)(mapStateToProps)(CommonSections);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/shared/CommonSections.js
// module id = 75
// module chunks = 0